// TODO: put this into the snackbarSagas file as NOT the default export.

import { call } from 'redux-saga/effects';
import toast from '@liquidweb-dev/undercurrent/toast';

function* snackbarSaga({
	error,
	errorMessage = 'Something went wrong',
	successMessage,
	successContentKey,
	variant = undefined,
}) {
	if (error) {
		yield call(toast.danger, errorMessage);
	} else if (variant === 'info') {
		yield call(toast.info, successMessage);
	} else if (successMessage || successContentKey) {
		yield call(toast.success, successMessage);
	}
}

export default snackbarSaga;
